function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "m228.561 41.97-225.438 390c-8.869 15.343 2.203 34.532 19.925 34.532h450.875c17.722 0 28.794-19.189 19.925-34.532l-225.438-390c-8.86-15.328-30.988-15.328-39.849 0z",
  fill: "#736e6e"
}), React.createElement("path", {
  d: "m496.136 449.498c-2.58 9.43-11.08 17-22.21 17h-450.88c-17.72 0-28.79-19.18-19.92-34.53l225.44-390c5.14-8.9 14.76-12.63 23.65-11.2l-222.09 384.2c-8.87 15.35 2.2 34.53 19.92 34.53z",
  fill: "#5a5555"
}), React.createElement("path", {
  d: "m43.64 421.976 196.185-339.991c3.848-6.669 13.474-6.669 17.323 0l196.184 339.992c3.847 6.667-.965 14.998-8.661 14.998h-392.369c-7.697-.001-12.509-8.332-8.662-14.999z",
  fill: "#f5de46"
}), React.createElement("path", {
  d: "m444.666 436.978h-392.36c-7.7 0-12.51-8.33-8.67-15l196.19-339.99c3.85-6.67 13.47-6.67 17.32 0l.57.99-184.08 319c-3.84 6.67.97 15 8.67 15h368.14l2.89 5c3.84 6.67-.97 15-8.67 15z",
  fill: "#f3d332"
}), React.createElement("g", null, React.createElement("path", {
  d: "m248.986 347.136c-12.407 0-22.5-10.094-22.5-22.5v-156.148c0-12.406 10.093-22.5 22.5-22.5s22.5 10.094 22.5 22.5v156.148c0 12.406-10.093 22.5-22.5 22.5z",
  fill: "#736e6e"
})), React.createElement("g", null, React.createElement("path", {
  d: "m246.486 324.638v-156.15c0-8.82 5.1-16.47 12.5-20.15-3.02-1.51-6.41-2.35-10-2.35-12.41 0-22.5 10.09-22.5 22.5v156.15c0 12.4 10.09 22.5 22.5 22.5 3.59 0 6.98-.85 10-2.36-7.4-3.68-12.5-11.33-12.5-20.14z",
  fill: "#5a5555"
})), React.createElement("g", null, React.createElement("path", {
  d: "m248.986 411.488c-14.612 0-26.5-11.888-26.5-26.5s11.888-26.5 26.5-26.5 26.5 11.888 26.5 26.5-11.888 26.5-26.5 26.5z",
  fill: "#736e6e"
})), React.createElement("g", null, React.createElement("path", {
  d: "m268.986 391.488c-14.61 0-26.5-11.89-26.5-26.5 0-2.01.22-3.96.66-5.84-11.81 2.66-20.66 13.24-20.66 25.84 0 14.61 11.89 26.5 26.5 26.5 12.6 0 23.18-8.85 25.84-20.66-1.88.44-3.83.66-5.84.66z",
  fill: "#5a5555"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 496.972 496.972",
    height: 512,
    viewBox: "0 0 496.972 496.972",
    width: 512
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/danger.49000a88.svg";
export { SvgComponent as ReactComponent };